import { Model } from 'backbone';

export const Transaction = Model.extend({
  /**
   * Return whether the payment item was mapped to a CostCentre.
   * @returns {boolean} Is this transaction mapped to a CostCentre?
   */
  hasCostCentre() {
    const paymentItem = this.get('payment_item');
    return !!paymentItem.costcentre;
  },

  /**
   * Return whether this transaction has a contact.
   * @returns {boolean} Does this transaction have a contact attached?
   */
  hasContact() {
    return !!this.get('contact');
  },

  /**
   * Can this contact be imported?
   * @returns {boolean} Whether this contact can be imported.
   */
  canImport() {
    return this.hasContact() && this.hasCostCentre();
  }
});



// WEBPACK FOOTER //
// ./epayment/models/transaction.js